import { Flex, Title, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { BackLink } from "./BackLink";
import { usePageTitle } from "../hooks/usePageTitle";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backTo?: string;
  action?: ReactNode;
  titleTestId?: string;
}

export function PageHeader({
  title,
  subtitle,
  backTo,
  action,
  titleTestId,
}: PageHeaderProps) {
  usePageTitle(title);

  return (
    <Flex justify="space-between" align="flex-start" wrap="wrap" gap="md">
      <div>
        {backTo && <BackLink to={backTo} />}
        <Title order={1} size="h2" data-testid={titleTestId}>
          {title}
        </Title>
        {subtitle && (
          <Text size="sm" c="dimmed" data-testid="page-header-subtitle">
            {subtitle}
          </Text>
        )}
      </div>
      {action && <div>{action}</div>}
    </Flex>
  );
}
